import styled from 'styled-components';

import { getCustomComponentProperty } from '@savgroup-front-common/core/helpers';
import { transparentize } from '@savgroup-front-common/primitive/helpers/cssColor';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';
import {
  LOGO_POSITION,
  SUPPORTED_PROPERTIES,
} from '@savgroup-front-common/types';

interface HeaderContainerProps {
  componentThemeName: string;
  enableServicePortal?: boolean;
}

export const $HeaderContainer = styled('div')<HeaderContainerProps>`
  width: 100%;
  padding-left: ${spacing('xl')};
  padding-right: ${spacing('xl')};
  height: ${spacing(16)};
  background-color: ${({ theme, componentThemeName }) => {
    return getCustomComponentProperty({
      theme,
      componentName: componentThemeName,
      property: SUPPORTED_PROPERTIES.BACKGROUND_COLOR,
      fallback: theme.colors.white,
    });
  }};
  border-bottom: ${({ theme }) =>
    `${theme.borders.thickness} solid ${transparentize(
      0.75,
      theme.colors.default,
    )}`};
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.06);
`;

export const $MenuContainer = styled.div<{ $position: LOGO_POSITION }>`
  position: relative;
  align-items: center;
  height: ${spacing(16)};
  display: flex;

  flex-direction: ${({ $position }) => {
    if ($position === LOGO_POSITION.RIGHT) {
      return 'row-reverse';
    }

    return 'row';
  }};

  justify-content: space-between;
`;

export const $RightSide = styled.div`
  display: flex;
`;

export const $EmptyDiv = styled.div<{ $width: number }>`
  height: ${spacing('px')};
`;
